import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/report/VehicleTempOkRate/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}